module.exports = __webpack_public_path__ + "static/media/haccp-icon.91926935.svg";